import { render } from "./result-page.vue?vue&type=template&id=18d46022&scoped=true"
import script from "./result-page.vue?vue&type=script&lang=js"
export * from "./result-page.vue?vue&type=script&lang=js"

import "./result-page.vue?vue&type=style&index=0&id=18d46022&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d46022"]])

export default __exports__